// From https://github.com/turbolinks/turbolinks/issues/272

window.TurbolinksGetForm = function (event) {
  for (let form of document.querySelectorAll(
    "form[method=get][data-remote=true]"
  )) {
    form.addEventListener("ajax:beforeSend", function (event) {
      const detail = event.detail,
        xhr = detail[0],
        options = detail[1];

      Turbolinks.visit(options.url);
      event.preventDefault();
    });
  }
};

$(document).on("turbo:load", TurbolinksGetForm);
